import { LibraryStore } from '@stores/Library/Library';
import { observer } from 'mobx-react';
import css from './LibraryNameBadges.module.scss';
import { TranscriptOnlyIndicator } from './TranscriptOnlyIndicator';

/**
 * A library's name plus its status badges, shared by the desktop table's Name cell
 * and the mobile list row. Both rendered this cluster independently, so adding a
 * third badge meant editing two files that had to agree.
 *
 * `observer` so the name and flags repaint when the library's data lands — the table
 * renders this inside a MUI cell, outside its own reactive scope.
 */
export const LibraryNameBadges = observer(function LibraryNameBadges({
  library,
}: {
  library: LibraryStore;
}) {
  return (
    <div className={css.nameRow}>
      <span className={css.name}>{library.name || ''}</span>
      {library.isTranscriptOnly && <TranscriptOnlyIndicator className={css.badge} />}
      {library.isDemo && <span className={css.demoBadge}>Demo</span>}
    </div>
  );
});
